import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
// import bluewindsor from '../../images/Windsor/bluewindsor.webp';
// import blackwindsor from '../../images/Windsor/blackwindsor.webp';
// import whitewindsor from '../../images/Windsor/whitewindsor.webp';
// import greywindsor from '../../images/Windsor/greywindsor.webp';

const bluewindsor ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor%2Fcuv-img-dsc-129.webp?alt=media&token=2859c9f9-a421-4a06-a74a-3a08a6b213c3"
const blackwindsor="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor%2Fcuv-img-dsc-088.webp?alt=media&token=9b7421a1-256b-4cf2-a143-6afb02c3f594"
const whitewindsor ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor%2Fcuv-img-dsc-087.webp?alt=media&token=36ffb558-dbc6-420e-afd6-299c29b60654"
const greywindsor ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor%2Fcuv-img-dsc-130.webp?alt=media&token=d86717bd-9a6d-4a21-a378-83f712d72e76"
const navywindsor ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor%2Fcuv-img-dsc-086.webp?alt=media&token=a91adf32-3c19-420b-93e4-a347426f6b77"
const redwindsor ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor%2Fcuv-img-dsc-128.webp?alt=media&token=8c4b50e5-b5bb-424e-986c-83d18cca1314"
const silverwindsor ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/windsor%2Fcuv-img-dsc-090.webp?alt=media&token=3763c91b-f0a8-4e4c-a292-49996dad4297"

const CustomCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [fixedImage, setFixedImage] = useState(bluewindsor); 

  const carImages = [
    { src: bluewindsor, alt: "blue", color: "#32434B" },
    { src: blackwindsor, alt: "black", color: "#393939" },
    { src: whitewindsor, alt: "White", color: "#DDDDDD" },
    { src: greywindsor, alt: "grey", color: "#B1ACA2" },
    { src: navywindsor, alt: "grey", color: "#36525f" },
    { src: redwindsor, alt: "grey", color: "#ec3110" },
    { src: silverwindsor, alt: "grey", color: "#f4efefe3" },
    

  ];

  const handleSelect = (index) => {
    setActiveIndex(index);
    setFixedImage(carImages[index].src); 
  };

  return (
    <div style={{ position: "relative",margin:0,padding:0 }}>
      <Carousel 
        activeIndex={activeIndex} 
        onSelect={handleSelect} 
        interval={null} 
        pause={false}
        indicators={false}
        controls={false}
      >
        {carImages.map((car, index) => (
          <Carousel.Item key={index}>
            <img className="d-block w-100" src={fixedImage} alt={car.alt} />
          </Carousel.Item>
        ))}
      </Carousel>

      {/* Custom Circle Indicators */}
      <div style={{ position: "absolute", left: "50%", transform: "translateX(-50%)", display: "flex", gap: "12px" }}>
        {carImages.map((car, index) => (
          <div
            key={index}
            onClick={() => handleSelect(index)}
            style={{
              width: "23px",
              height: "24px",
              borderRadius: "50%",
              backgroundColor: activeIndex === index ? car.color : car.color, 
              cursor: "pointer",
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default CustomCarousel;